@if (result(); as item) {
  <div class="flex flex-col gap-0.5">
    <div class="flex flex-row text-sm color-primary">
      <span>{{ item.cartikelnummer }}</span>
    </div>
    <div class="flex flex-row">
      <span class="font-semibold">{{ item[5] }}</span>
    </div>
    @if (item[26]) {
      <div class="flex flex-row">
        <span class="text-xs text-light">{{ item[26] }}</span>
      </div>
    }
    @if (item[27]) {
      <div class="flex flex-row">
        <span class="text-xs text-light">{{ item[27] }}</span>
      </div>
    }
    @if (item[28]) {
      <div class="flex flex-row">
        <span class="text-xs text-light">{{ item[28] }}</span>
      </div>
    }
    @if (item[29]) {
      <div class="flex flex-row">
        <span class="text-xs text-light">{{ item[29] }}</span>
      </div>
    }
    @if (item[13] !== null && item[13] !== undefined && item['lagereh']) {
      <div class="flex flex-row">
        <span class="text-xs font-semibold text-light"
          >Lagerstand Filiale: {{ item[13] | number: '1.2-2' }}
          {{ item['lagereh'] }}</span
        >
      </div>
    }
    @if (
      item['lagerstand_gesamt'] !== null &&
      item['lagerstand_gesamt'] !== undefined &&
      item['lagereh']
    ) {
      <div class="flex flex-row">
        <span class="text-xs font-semibold text-light"
          >Lagerstand Gesamt: {{ item['lagerstand_gesamt'] | number: '1.2-2' }}
          {{ item['lagereh'] }}</span
        >
      </div>
    }
  </div>
}
